import * as React from 'react';

function SvgLongtailProcessCheckIn(props) {
  return (
    <svg width={20} height={20} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M10.533.297l.099.045 8.727 4.76a.75.75 0 01.384.556l.007.102v12.694a.75.75 0 01-.648.743l-.102.007h-5.183a.75.75 0 01-.101-1.493l.101-.007 4.432-.001V6.205l-7.977-4.351-7.977 4.351v3.266a.75.75 0 01-.648.744l-.102.006a.75.75 0 01-.743-.648l-.007-.102V5.76a.75.75 0 01.305-.604l.086-.055L9.914.341a.75.75 0 01.62-.044zM7.22 11.104l.081.076 3.113 3.383a.75.75 0 01.071.925l-.071.09-3.113 3.384a.75.75 0 01-1.173-.929l.07-.087 1.853-2.015H1a.75.75 0 01-.102-1.492L1 14.432l7.255-.001-2.058-2.235a.75.75 0 01-.032-.979l.076-.08a.75.75 0 01.979-.033z" />
    </svg>
  );
}

export default SvgLongtailProcessCheckIn;
